import { useMutation, useQuery, useQueryClient } from 'react-query';
import { fetchClient } from './api';

const apiClient = fetchClient();

export const getNewsletters = () => apiClient.get('/newsletter').then(res => res.data);

export const useNewsletters = () => useQuery('newsletters', getNewsletters);

const createNewsletter = async ({ body, subject }) =>
  await apiClient.post('/newsletter', { body, subject }).then(res => res.data);

export const useCreateNewsletter = function () {
  const queryClient = useQueryClient();
  return useMutation(createNewsletter, {
    onSuccess: () => queryClient.invalidateQueries('newsletters'),
  });
};

const updateNewsletter = async ({ body, subject }) =>
  await apiClient.patch('/newsletter', { body, subject }).then(res => res.data);

export const useUpdateNewsletter = function () {
  const queryClient = useQueryClient();
  return useMutation(updateNewsletter, {
    onSuccess: () => queryClient.invalidateQueries('newsletters'),
  });
};

const sendMonthlyReview = ({ next }) =>
  apiClient.post('/scheduled-notification/monthly-review', { next }).then(res => res.data);

export const useSendMonthlyReview = () => useMutation(sendMonthlyReview);
